"use strict";

var _classCallCheck = require("/media/rahul/New Volume/IITP/summer/OpenSource/Resume/github/resumeapp/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/media/rahul/New Volume/IITP/summer/OpenSource/Resume/github/resumeapp/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/media/rahul/New Volume/IITP/summer/OpenSource/Resume/github/resumeapp/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/media/rahul/New Volume/IITP/summer/OpenSource/Resume/github/resumeapp/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/media/rahul/New Volume/IITP/summer/OpenSource/Resume/github/resumeapp/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TriangleDrawer = void 0;

var PolygonDrawerBase_1 = require("./PolygonDrawerBase");

var TriangleDrawer =
/*#__PURE__*/
function (_PolygonDrawerBase_1$) {
  _inherits(TriangleDrawer, _PolygonDrawerBase_1$);

  function TriangleDrawer() {
    _classCallCheck(this, TriangleDrawer);

    return _possibleConstructorReturn(this, _getPrototypeOf(TriangleDrawer).apply(this, arguments));
  }

  _createClass(TriangleDrawer, [{
    key: "getSidesData",
    value: function getSidesData(particle, radius) {
      return {
        count: {
          denominator: 2,
          numerator: 3
        },
        length: radius * 2
      };
    }
  }, {
    key: "getCenter",
    value: function getCenter(particle, radius) {
      return {
        x: -radius,
        y: radius / 1.66
      };
    }
  }]);

  return TriangleDrawer;
}(PolygonDrawerBase_1.PolygonDrawerBase);

exports.TriangleDrawer = TriangleDrawer;